import React, { useEffect, useState } from "react";
import { Button, Card, Col, Flex, Form, InputNumber, Row, Spin, Table, Typography } from 'antd';
import 'dayjs/locale/uk';
import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import { useGetLiqpayFormMutation, useGetUserDetailsQuery } from '../../services/auth/authService'
const { Text } = Typography;

const ReplenishmentSubComponent = () => {
    const { data: userInfo = {}, isFetching: isUserInfoFetching } = useGetUserDetailsQuery()
    const [sum, setSum] = useState(50);
    const [getLiqPayForm, { isLoading: isLiqpayLoading, data: liqpayForm }] = useGetLiqpayFormMutation();
    const presetAmounts = [100, 200, 500];
    dayjs.extend(LocalizedFormat);
    useEffect(() => {
        if (sum > 0) {
            getLiqPayForm(sum);
        }
    }, [sum, getLiqPayForm]);
    const columns = [
        {
            title: 'Дата',
            dataIndex: 'date',
            key: 'date',
            width: '45%',
            render: (date) => dayjs(date).locale('uk').format('LLLL')
        },
        {
            title: 'Хто поповнив',
            key: 'paid_by',
            width: '30%',
            render: (_, record) => {
                if (record.paid_by_name && record.paid_by_phone) return `${record.paid_by_name} (${record.paid_by_phone})`;
                return record.paid_by_name || record.paid_by_phone || '-';
            }
        },
        {
            title: 'Сума',
            dataIndex: 'amount',
            key: 'amount',
            width: '25%',
            render: (amount) => parseInt(amount) >= 0 ? `+${amount}` : amount
        },
    ];
    return (
        <div className="compact-profile-shell">
            <Card
                className="compact-section-card compact-payment-card replenishment-payment-card"
                bordered={false}
                title={<div className="compact-card-title">Поповнити баланс</div>}
            >
                <Row gutter={[16, 16]} align="stretch">
                    <Col xs={24} lg={10}>
                        <div className="parking-topup-balance">
                            <Text className="parking-topup-balance__label">Поточний баланс</Text>
                            <div className="parking-topup-balance__value">
                                {isUserInfoFetching ? <Spin /> : `${userInfo.balance ?? 0} грн`}
                            </div>
                        </div>
                        <Flex className="parking-topup-presets" gap={8} wrap="wrap">
                            {presetAmounts.map((preset) => (
                                <Button
                                    key={preset}
                                    size="small"
                                    type={sum === preset ? "primary" : "default"}
                                    onClick={() => setSum(preset)}
                                >
                                    {preset} грн
                                </Button>
                            ))}
                        </Flex>
                        <Form layout="vertical">
                            <Form.Item label="Сума">
                                <InputNumber
                                    type="number"
                                    min={1}
                                    onChange={(value) => setSum(value || 0)}
                                    value={sum}
                                    addonAfter="₴"
                                    controls={false}
                                    style={{ width: "100%" }}
                                />
                            </Form.Item>
                        </Form>
                    </Col>
                    <Col xs={24} lg={14}>
                        <div className="replenishment-payment-widget">
                            {isLiqpayLoading ? (
                                <Spin />
                            ) : (
                                <div dangerouslySetInnerHTML={{ __html: liqpayForm || "" }} />
                            )}
                        </div>
                    </Col>
                </Row>
            </Card>
            <Card className="compact-section-card" bordered={false}>
                <div className="compact-section-head">
                    <Text className="compact-section-title">Поповнення</Text>
                    <Text className="compact-section-subtitle">
                        {(userInfo.transactions?.filter((item) => item.amount > 0).length) || 0} надходжень
                    </Text>
                </div>
                <Table
                    className="compact-table"
                    bordered
                    scroll={{
                        x: 560,
                        y: 500,
                    }}
                    columns={columns}
                    rowKey={(record) => record.id}
                    pagination={false}
                    dataSource={userInfo.transactions?.filter(i => i.amount > 0)}
                    rowClassName={(record) => parseInt(record.amount) < 0 ? 'amount-negative' : 'amount-positive'}
                    size="small"
                    loading={isUserInfoFetching}
                />
            </Card>
        </div>
    )
}

export default ReplenishmentSubComponent
